import React from 'react'

function Reviews(props) {
  return (
    <div className="course-details-card mt--40">
                    <div className="course-details-two-content">
                      {/* <CurriculumContent /> */}
                      {/* <div className="feature-style-6 mt--20">
                                                <div className="edu-feature-list color-variation-1">
                                                    <div className="icon">
                                                        <img src="/images/about/about-05/student.png" alt="Icons Images" />
                                                    </div>
                                                    <div className="content">
                                                        <h6 className="title">Industry Expert Instructor</h6>
                                                        <p className="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, eiusmoded tempor incididunt dolore magna aliqua.</p>
                                                    </div>
                                                </div>
                                            </div> */}
                      <div className="edu-comment">
                        <div className="thumbnail">
                          <img
                            src={props.image}
                            alt="Student Thumb"
                          />
                        </div>
                        <div className="comment-content">
                          <div className="comment-top">
                            <h6 className="title">{props.name}</h6>
                            <div className="rating eduvibe-course-rating-stars">
                              <i className="icon-Star"></i>
                              <i className="icon-Star"></i>
                              <i className="icon-Star"></i>
                              <i className="icon-Star"></i>
                              <i className="icon-Star"></i>
                            </div>
                          </div>
                          <span className="subtitle">
                            {props.main}
                          </span>
                          <p>
                            {props.para}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
  )
}

export default Reviews